<template>
  <v-card
    color="transparent"
    class="elevation-0"
    :class="$vuetify.breakpoint.smAndDown ? 'mt-0 px-0' : 'mt-10 px-4'"
  >
    <h2 class="text-h5 mb-6">
      Tapahtumat
    </h2>
    <v-timeline dense>
      <v-timeline-item
        v-for="(item, i) in logItems"
        :key="i"
        color="primary"
        small
      >
        <div
          class="elevation-0"
        >
          <p class="my-2 text-caption">
            <b class="primary--text">
              {{ item.logTimeStamp | date }} klo
              {{ item.logTimeStamp | date({ type: 'time' }) }}
            </b>
            <br>
            {{ item.name }} {{ item.description }}
          </p>
        </div>
      </v-timeline-item>
    </v-timeline>
  </v-card>
</template>
<script>
export default {
  props: {
    logItems: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
